export const axiosDefaults = {
    skipAuth: false,
};
